export const en = {
  taskCount: 'COMPLETED TASKS/TOTAL TASKS'
};

export type Translations = typeof en;
